<template>
    <div>
        <!-- <section id="secur" class="ptb-60" style="background: url('/banner.jpg')no-repeat center center/cover; opacity: 1;">
            <div class="container">
                <div class="row align-items-center justify-content-between">
                    <div class="col-md-7 col-lg-6">
                        <div class="cta-content-wrap text-white">
                            <h2 class="text-white"><i class="fas fa-lock mr-2"></i> Securité assurée</h2>
                            <p>Afin de garantir une sécurité optimale dinflow répond à trois exigences majeures :
                            <br><br> <span class="text-bold primary">• La confidentialité</span> : les transactions des données sont cryptées sur le réseau par le mise en place du protocole HTTPS basée sur les clés de chiffrement SSL/TLS
                            <br><br> <span class="text-bold primary">• L’integrité</span> : l’accès à l’information est conditionnée par la mise en place d’un système de gestion des roles, permissions et droits d’accès:
                            <br><br> <span class="text-bold primary">• La haute disponibilité</span> : Le système est équipé d’automates informatiques permettant d’effectuer la sauvegarde automatique des données pour une gestion optimale des risques et la recuperation des informations critiques après sinistre.</p>
                        </div>
                    </div>
                    <div class="col-md-5 col-lg-4">
                        <div class="cta-img-wrap text-center">
                            <LottieAnimation
                            ref="anim"
                            :animationData="require('@/assets/json/secure.json')"
                            loop
                            style="width: 100%;"
                            class="img-fluid" background="transparent"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section> -->
        <div id="avant" class="feature-section ptb-100 " style="background:white">
            <div class="container">
                <div class="row justify-content-center mb-4">
                    <div class="col-md-9 col-lg-8 mb-4">
                        <div class="section-heading text-center">
                            <h2 style="color: #313A58;">Pourquoi FDSU Docs ?</h2>
                            <p class="lead">Pourquoi gérer et organiser son contenu électronique avec FDSU Docs ?</p>
                        </div>
                    </div>
                </div>
                <div class="row align-items-center justify-content-between">
                    <div class="col-md-7 col-lg-6">
                        <div class="feature-content-wrap">
                            <h3 style="color: #313A58;">Eliminer les documents papier</h3>
                            <p>L’utilisation de documents papier au quotidien s’avère être un processus coûteux et
                                chronophage s’accompagnant de nombreuses contraintes</p>
                            <ul class="py-3">
                                <li> 
                                    <i class="mr-2 bx bxs-check-circle text-success"></i>
                                    Risque élevé de perte en cas de catastrophe naturelle
                                </li>
                                <li> 
                                    <i class="mr-2 bx bxs-check-circle text-success"></i>
                                    Espace de stockage physique nécessaire
                                </li>
                                <li> 
                                    <i class="mr-2 bx bxs-check-circle text-success"></i>
                                    Recherche de documents laborieuse
                                </li>
                                <li> 
                                    <i class="mr-2 bx bxs-check-circle text-success"></i>
                                    Problème de sécurité et de confidentialité des documents
                                </li>
                                <li> 
                                    <i class="mr-2 bx bxs-check-circle text-success"></i>
                                    Traitement manuel des processus et circuits d’approbation 
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-md-5 col-lg-6 d-none d-md-block d-lg-block">
                        <div class="feature-img-wrap text-center">
                            <LottieAnimation ref="anim" :animationData="require('@/assets/json/login.json')" loop
                                style="width: 100%;" class="img-fluid" background="transparent" />
                        </div>
                    </div>
                </div>
                <div class="row align-items-center justify-content-between mt-5">
                    <div class="col-md-5 col-lg-6 d-none d-md-block d-lg-block">
                        <div class="feature-img-wrap text-center">
                            <LottieAnimation ref="anim" :animationData="require('@/assets/json/collaboration.json')" loop
                                style="width: 100%;" class="img-fluid" background="transparent" />
                        </div>
                    </div>
                    <div class="col-md-7 col-lg-6">
                        <div class="feature-content-wrap">
                            <h3 style="color: #313A58;">Accélérez votre transformation digitale</h3>
                            <p>Intuitive, au design de classe mondiale et s’intégrant facilement à votre environnement
                                de travail, la plateforme digitale dinflow vous permettra rapidement de:</p>
                            <ul class="py-3">
                                <li> <i class="mr-2 bx bxs-check-circle text-success"></i>
                                    Éliminer vos contraintes liées au mode papier
                                </li>
                                <li> <i class="mr-2 bx bxs-check-circle text-success"></i>
                                    Accroître la productivité de vos collaborateurs
                                </li>
                                <li> <i class="mr-2 bx bxs-check-circle text-success"></i>
                                    Réduire de manière significative vos coûts opérationnels
                                </li>
                                <li> <i class="mr-2 bx bxs-check-circle text-success"></i>
                                    Renforcer la sécurité et confidentialité de vos données
                                </li>
                                <li> <i class="mr-2 bx bxs-check-circle text-success"></i>
                                    Dédier vos collaborateurs à des missions à valeur
                                    ajoutée
                                </li>
                                <li> <i class="mr-2 bx bxs-check-circle text-success"></i>
                                    Contribuer aux objectives de développement durables
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import LottieAnimation from 'lottie-web-vue'
export default {
    components: {
        LottieAnimation
    }
}
</script>
<style>
    .primary{
        color: #4abbd5;
    }
</style>